exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".care-team-tasks--QGATnn_wowDw-PAsrpCXy {\n  display: flex;\n  justify-content: center;\n  padding: 2rem 0;\n}\n", ""]);

// exports
exports.locals = {
	"paginationContainer": "care-team-tasks--QGATnn_wowDw-PAsrpCXy",
	"paginationContainer": "care-team-tasks--QGATnn_wowDw-PAsrpCXy"
};